import React from "react";

import { Helpers } from "../../config/Helpers"
import {ReactSession} from "react-client-session";
import {decode as base64_decode, encode as base64_encode} from "base-64";
import queryString from "query-string";
import {toast} from "react-toastify";
import {Button, Modal, ModalBody, ModalFooter} from "reactstrap";
import QRCode from "react-qr-code";

class OrderActiveDetails extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',
            sessUserType: (ReactSession.get("sess_usertype")) ? ReactSession.get("sess_usertype") : '',
            orderData: '',
            orderDetailsData: [],
            kodeTransaksiOrder: '',
            isModalOutOpen: false,
            isModalReceiveOpen: false,
            urlParam: queryString.parse(window.location.search),
            branchCode: '',
            time: {},
            seconds: 0,
            loading: true,
        }
        this.timer = 0;
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            const kodeOrder = (this.state.urlParam.trxid) ? base64_decode(this.state.urlParam.trxid) : '';

            this.setState({
                kodeTransaksiOrder: kodeOrder
            }, () => {
                this.getOrderDetail();
            });
        }
    }

    copyClipboard = (value) => {
        if(navigator.clipboard){
            navigator.clipboard.writeText(value);
            toast.success('Berhasil disalin');
        }
    };

    getOrderDetail = () => {
        Helpers.getListOrder('no',this.state.kodeTransaksiOrder,'','','').then(res => {
            if(!res || res.length === 0){
                this.setState({ loading: false });
                return;
            }

            const status_overall = res[0].status_overall;
            const StatusDirectPayment = res[0].StatusDirectPayment;
            const MetodePembayaran = res[0].MetodePembayaran;
            const SisaWaktuPembayaran = res[0].SisaWaktuPembayaran;
            const SisaWaktuPembayaranSeconds = res[0].SisaWaktuPembayaranSeconds;
            const KodeCabang = res[0].KodeCabang;
            const PickupOut = res[0].PickupOut;
            const PickupReceive = res[0].PickupReceive;
            const TipePengiriman = res[0].TipePengiriman;

            let btn_payment = false;
            let tv_sisa_waktu_bayar = false;
            let tv_sisa_waktu_bayar_view = '';
            let ll_information = false;
            let btn_cancel = false;
            let btn_qrcode = false;
            let ll_information_qrcode = false;
            let ll_qrcode = false;
            let cv_qrcode_out = false;
            let btn_qrcode_out = '';
            let btn_qrcode_receive = '';
            let btn_change_delivery = '';
            let btn_change_payment = '';

            if(TipePengiriman === 'Ambil Sendiri' && PickupReceive == "Proses" && status_overall !== "Order Canceled" && parseInt(SisaWaktuPembayaranSeconds) > 0){
                btn_change_delivery = <button className="detail-btn-outline" onClick={() => {this.handleChangeDeliveryMethod()}}>
                    Ubah Pengiriman
                </button>;
            }

            if(status_overall == "Waiting Payment"){
                btn_payment = true;
            }else{
                if(status_overall == "Order Processed" && StatusDirectPayment == "Pending" && (MetodePembayaran == "Bank" || MetodePembayaran == "e-Money" || MetodePembayaran == "Credit Card" || MetodePembayaran == "Fintech") && parseInt(SisaWaktuPembayaranSeconds) > 0){
                    btn_payment = true;
                    tv_sisa_waktu_bayar = true;

                    this.setState({
                        seconds: parseInt(res[0].SisaWaktuPembayaranSeconds)/1000
                    }, () => {
                        let timeLeftVar = this.secondsToTime(this.state.seconds);
                        this.setState({
                            time: timeLeftVar
                        }, () => {
                            this.startTimer();
                        });
                    });
                }else if(status_overall == "Order Processed" && StatusDirectPayment == "Pending" && (MetodePembayaran == "Bank" || MetodePembayaran == "e-Money" || MetodePembayaran == "Credit Card" || MetodePembayaran == "Fintech") && parseInt(SisaWaktuPembayaranSeconds) == 0){
                    btn_payment = false;
                    tv_sisa_waktu_bayar = true;
                    tv_sisa_waktu_bayar_view = <div>Waktu pembayaran habis, order telah dibatalkan atau dalam proses menunggu konfirmasi pembayaran.</div>
                }else{
                    btn_payment = false;
                    tv_sisa_waktu_bayar = false;
                }
            }

            if(status_overall == "Order Processed" && MetodePembayaran == "Limit"){
                ll_information = true;
            }else{
                ll_information = false;
            }

            if(status_overall == "Order Processed"){
                if(MetodePembayaran == "Bank" || MetodePembayaran == "e-Money" || MetodePembayaran == "Credit Card" || MetodePembayaran == "Fintech"){
                    if(StatusDirectPayment == "Pending" && parseInt(SisaWaktuPembayaranSeconds) > 0){
                        btn_cancel = true;
                        btn_change_payment = <button className="detail-btn-outline" onClick={() => {this.handleChangePaymentMethod()}}>
                            Ubah Pembayaran
                        </button>;
                    }else{
                        btn_cancel = false;
                    }
                }else if(MetodePembayaran == "Saldo"){
                    btn_cancel = false;
                }else{
                    btn_cancel = true;
                }
            }else{
                btn_cancel = false;
            }

            if(status_overall == "Waiting Pickup"){
                btn_qrcode = false;
                ll_information_qrcode = true;
                ll_qrcode = true;

                if(this.state.sessUserType == "logistik"){
                    cv_qrcode_out = true;

                    if(PickupOut == "Done"){
                        btn_qrcode_out = <button className="detail-btn-outline detail-btn-disabled" disabled>
                            Pengambilan barang telah dilakukan
                        </button>
                    }else{
                        btn_qrcode_out = <button className="detail-btn-outline" onClick={() => {this.handleModalQROut()}}>
                            QRCode Pengambilan Barang
                        </button>
                    }

                    if(PickupReceive == "Done"){
                        btn_qrcode_receive = <button className="detail-btn-outline detail-btn-disabled" disabled>
                            Barang telah diterima customer
                        </button>
                    }else{
                        btn_qrcode_receive = <button className="detail-btn-outline" onClick={() => {this.handleModalQRReceive()}}>
                            Scan QRCode Penerimaan Barang
                        </button>
                    }
                }else{
                    cv_qrcode_out = false;

                    if(PickupReceive == "Done"){
                        btn_qrcode_receive = <button className="detail-btn-outline detail-btn-disabled" disabled>
                            Barang telah diterima customer
                        </button>
                    }else{
                        if(TipePengiriman == 'Biteship'){
                            btn_qrcode_receive = '';
                        }else{
                            btn_qrcode_receive = <button className="detail-btn-outline" onClick={() => {this.handleModalQRReceive()}}>
                                QRCode Penerimaan Barang
                            </button>
                        }
                    }
                }
            }else{
                btn_qrcode = false;
                ll_information_qrcode = false;
                ll_qrcode = false;
            }

            this.setState({
                orderData: res[0],
                btn_payment: btn_payment,
                tv_sisa_waktu_bayar: tv_sisa_waktu_bayar,
                tv_sisa_waktu_bayar_view: tv_sisa_waktu_bayar_view,
                ll_information: ll_information,
                btn_cancel: btn_cancel,
                btn_qrcode: btn_qrcode,
                ll_information_qrcode: ll_information_qrcode,
                ll_qrcode: ll_qrcode,
                cv_qrcode_out: cv_qrcode_out,
                btn_qrcode_out: btn_qrcode_out,
                btn_qrcode_receive: btn_qrcode_receive,
                btn_change_delivery: btn_change_delivery,
                btn_change_payment: btn_change_payment,
                branchCode: KodeCabang,
                loading: false,
            }, () => {
                this.getListOrderDetail();
            });
        })
    };

    handleModalQROut = () => {
        this.setState({ isModalOutOpen: !this.state.isModalOutOpen });
    };

    handleModalQRReceive = () => {
        this.setState({ isModalReceiveOpen: !this.state.isModalReceiveOpen });
    };

    getListOrderDetail = () => {
        Helpers.getListOrderDetail(this.state.kodeTransaksiOrder).then(res => {
            this.setState({ orderDetailsData: res });
        })
    };

    handleCancel = () => {
        if (window.confirm('Apakah anda yakin akan membatalkan order ini?')) {
            Helpers.cancelOrder(this.state.kodeTransaksiOrder, this.state.sessEmail).then(res => {
                if(res.length > 0){
                    if(res[0].alert == 'success'){
                        setTimeout(function() {
                            window.location.href = './account-orders';
                        }, 1000);
                    }

                    toast[res[0].alert](res[0].message);
                }else{
                    toast.error(Helpers.MSG_ERROR);
                }
            })
        }
    };

    handlePayment = () => {
        const MetodePembayaran = this.state.orderData.MetodePembayaran;
        const KodePaymentGateway = this.state.orderData.KodePaymentGateway;
        const KodeTransaksiOrder = this.state.orderData.KodeTransaksiOrder;

        if(MetodePembayaran == "Limit"){
            //dialogFormUploadPayment();
        }else if(MetodePembayaran == "Bank" || MetodePembayaran == "e-Money" || MetodePembayaran == "Credit Card" || MetodePembayaran == "Fintech"){
            if(KodePaymentGateway == ""){
                console.log('Empty Payment');
            }else{
                window.location.href = './account-orders-payment?trxid=' + base64_encode(KodeTransaksiOrder) + '&payment=' + base64_encode(KodePaymentGateway);
            }
        }
    };

    handleChangeDeliveryMethod = () => {
        Helpers.getChangeDeliveryMethod(this.state.kodeTransaksiOrder).then(res => {
            if(res.length > 0){
                window.location.href = './account-orders-payment?trxid=' + base64_encode(res[0].KodeChangeDelivery) + '&payment=' + base64_encode(res[0].KodePaymentGateway) + '&type=change_delivery';
            }else{
                window.location.href = './change-delivery-method?trxid=' + base64_encode(this.state.kodeTransaksiOrder);
            }
        })
    };

    handleChangePaymentMethod = () => {
        window.location.href = './change-payment-method?trxid=' + base64_encode(this.state.kodeTransaksiOrder);
    };

    secondsToTime = (secs) => {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    startTimer = () => {
        if (this.timer == 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown = () => {
        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
            tv_sisa_waktu_bayar_view: <div>Sisa Waktu Pembayaran: {((this.state.time.h.toString().length < 2) ? '0'+this.state.time.h : this.state.time.h)}:{((this.state.time.m.toString().length < 2) ? '0'+this.state.time.m : this.state.time.m)}:{((this.state.time.s.toString().length < 2) ? '0'+this.state.time.s : this.state.time.s)}</div>
        });

        if (seconds == 0) {
            clearInterval(this.timer);
            window.location.reload();
        }
    }

    handleTrackingClick = () => {
        window.location.href = './account-orders-status?trxid=' + base64_encode(this.state.kodeTransaksiOrder);
    };

    render() {
        const showActionBar = this.state.btn_cancel || this.state.btn_payment || (this.state.ll_qrcode && this.state.cv_qrcode_out) || (this.state.ll_qrcode && !this.state.cv_qrcode_out) || this.state.btn_change_delivery || this.state.btn_change_payment;

        return (
            <>
                <Modal
                    size={'md'}
                    isOpen={this.state.isModalOutOpen}
                    toggle={() => {this.handleModalQROut()}}
                    contentClassName="modal-picker-content">
                    <ModalBody className="modal-picker-body">
                        <div className="modal-picker-header">
                            <div className="modal-picker-title">
                                <span className="modal-picker-icon"><i className="fi-rs-box-alt"></i></span>
                                QRCode Pengambilan Barang
                            </div>
                            <button type="button" className="modal-picker-close" onClick={() => {this.handleModalQROut()}}>
                                <i className="fi-rs-cross"></i>
                            </button>
                        </div>
                        <div style={{padding: '30px 20px', textAlign: 'center'}}>
                            <QRCode value={'out'+this.state.kodeTransaksiOrder} />
                        </div>
                    </ModalBody>
                </Modal>
                <Modal
                    size={'md'}
                    isOpen={this.state.isModalReceiveOpen}
                    toggle={() => {this.handleModalQRReceive()}}
                    contentClassName="modal-picker-content">
                    <ModalBody className="modal-picker-body">
                        <div className="modal-picker-header">
                            <div className="modal-picker-title">
                                <span className="modal-picker-icon"><i className="fi-rs-box-alt"></i></span>
                                QRCode Penerimaan Barang
                            </div>
                            <button type="button" className="modal-picker-close" onClick={() => {this.handleModalQRReceive()}}>
                                <i className="fi-rs-cross"></i>
                            </button>
                        </div>
                        <div style={{padding: '30px 20px', textAlign: 'center'}}>
                            <QRCode value={'rcv'+this.state.kodeTransaksiOrder} />
                        </div>
                    </ModalBody>
                </Modal>

                <main className={"main pages detail-page-wrap" + (showActionBar ? " detail-page-has-actionbar" : "")}>
                    <div className="detail-topbar">
                        <a href="./account-orders" className="detail-topbar-back"><i className="fi-rs-arrow-small-left"></i></a>
                        <h1 className="detail-topbar-title">Detail Pesanan</h1>
                    </div>

                    <div className="detail-wrap">
                    {
                        this.state.loading ? (
                            <div className="detail-card">
                                <div className="detail-card-head">
                                    <span className="detail-card-accent"></span>
                                    <span className="detail-card-title">Memuat data...</span>
                                </div>
                            </div>
                        ) : !this.state.orderData ? (
                            <div className="order-empty">
                                <i className="fi-rs-receipt"></i>
                                <p>Data transaksi tidak ditemukan</p>
                            </div>
                        ) : (
                        <>
                        {/* Card: Status */}
                        <div className="detail-card">
                            <div className="detail-card-head">
                                <span className="detail-card-accent"></span>
                                <span className="detail-card-title">{this.state.orderData.status_overall}</span>
                                <a href="javascript:void(0);" className="detail-card-link" onClick={() => {this.handleTrackingClick()}}>Lihat Detail</a>
                            </div>
                            <div className="detail-info-box">
                                <div className="detail-info-row">
                                    <i className="fi-rs-receipt"></i>
                                    <span className="detail-info-label">No. Order</span>
                                    <span className="detail-info-value detail-info-copy" onClick={() => {this.copyClipboard(this.state.orderData.KodeTransaksiOrder)}}>
                                        {this.state.orderData.KodeTransaksiOrder} <i className="fi-rs-copy-alt"></i>
                                    </span>
                                </div>
                                <div className="detail-info-row">
                                    <i className="fi-rs-calendar"></i>
                                    <span className="detail-info-label">Tanggal</span>
                                    <span className="detail-info-value">{this.state.orderData.date_d + ' ' + this.state.orderData.date_m + ' ' + this.state.orderData.date_y + ', ' + this.state.orderData.date_t + ' WIB'}</span>
                                </div>
                                <div className="detail-info-row">
                                    <i className="fi-rs-user"></i>
                                    <span className="detail-info-label">Pemesan</span>
                                    <span className="detail-info-value">{this.state.orderData.NamaWarung}</span>
                                </div>
                            </div>
                        </div>

                        {/* Card: Detail Produk */}
                        <div className="detail-card">
                            <div className="detail-card-head">
                                <span className="detail-card-accent"></span>
                                <span className="detail-card-title">Detail Produk</span>
                            </div>
                            <div className="detail-product-list">
                                {
                                    this.state.orderDetailsData.map((object, i) => (
                                        <div className="detail-product-item" key={i}>
                                            <div className="detail-product-name">{object.NamaBarang}</div>
                                            <div className="detail-product-meta">
                                                <span>{object.Qty} {object.UnitBarang} x Rp {object.HargaSatuan}</span>
                                                <span className="detail-product-price">Rp {object.Harga}</span>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                        {/* Card: Info Pengiriman */}
                        <div className="detail-card">
                            <div className="detail-card-head">
                                <span className="detail-card-accent"></span>
                                <span className="detail-card-title">Info Pengiriman</span>
                            </div>
                            <div className="detail-info-box">
                                <div className="detail-info-row">
                                    <i className="fi-rs-package"></i>
                                    <span className="detail-info-label">Metode</span>
                                    <span className="detail-info-value">{(this.state.orderData.Kurir) ? this.state.orderData.Kurir : this.state.orderData.TipePengiriman}</span>
                                </div>
                                <div className="detail-info-row detail-info-row-top">
                                    <i className="fi-rs-marker"></i>
                                    <span className="detail-info-label">Alamat</span>
                                    <span className="detail-info-value detail-info-value-normal">{this.state.orderData.Alamat}</span>
                                </div>
                            </div>

                            {
                                this.state.ll_information && (
                                    <div className="detail-note-box">
                                        <i className="fi-rs-info"></i>
                                        <span>Mohon menunggu, order sedang dipersiapkan. Estimasi pengiriman order dalam 3 - 5 hari kerja.</span>
                                    </div>
                                )
                            }
                            {
                                this.state.ll_information_qrcode && (
                                    <div className="detail-note-box">
                                        <i className="fi-rs-info"></i>
                                        <span>
                                            <strong>Perhatian:</strong> Pengambilan barang wajib menggunakan QR Code, tunjukkan QR Code berikut kepada tim logistik waroq saat pengambilan barang di gudang dan setelah menerima barang, klik tombol dibawah ini untuk menampilkan.<br/>
                                            Untuk pengiriman menggunakan metode delivery, estimasi pengiriman order dalam <strong>3 - 5 hari kerja.</strong><br/><br/>

                                            <strong>Alamat pengambilan barang:</strong><br/>
                                            {
                                                this.state.branchCode=='CBNG-18-020001' && (
                                                    <>
                                                        Mayapada Tower 2 (Gudang Waroq/Gudang BBX Mart)<br/>
                                                        Jl. Jend. Sudirman No.Kav. 27, RT.4/RW.2, Kuningan, Karet, Kecamatan Setiabudi, Kota Jakarta Selatan, DKI Jakarta 12920<br/><br/>
                                                    </>
                                                )
                                            }
                                            {
                                                this.state.branchCode=='CBNG-18-020002' && (
                                                    <>
                                                        RUKO MAYAPADA, Jl. Wibawa Mukti II RT.006/RW.001, Jatiluhur, Kec. Jatiasih (Ruko mayapada), KOTA BEKASI, JATIASIH, JAWA BARAT, ID, 17425<br/><br/>
                                                    </>
                                                )
                                            }
                                            {
                                                this.state.branchCode=='CBNG-18-020003' && (
                                                    <>
                                                        Mayapada Hospital Surabaya (MHSB), Jl. Mayjen Sungkono No.20, Pakis, Kec. Sawahan, Kota SBY, Jawa Timur 60256<br/><br/>
                                                    </>
                                                )
                                            }

                                            <strong>Jam operasional gudang untuk pick up</strong>:<br/>
                                            - Senin-Jumat: <strong>Jam 08.00 sd 18.00</strong><br/>
                                            - Sabtu: <strong>Jam 10.00 sd 17.00</strong><br/>
                                            - Minggu: <span style={{color: '#F0142F'}}><strong>Tidak beroperasi</strong></span>
                                        </span>
                                    </div>
                                )
                            }
                        </div>

                        {/* Card: Rincian Pembayaran */}
                        <div className="detail-card">
                            <div className="detail-card-head">
                                <span className="detail-card-accent"></span>
                                <span className="detail-card-title">Rincian Pembayaran</span>
                            </div>
                            <div className="detail-info-box">
                                <div className="detail-info-row">
                                    <i className="fi-rs-credit-card"></i>
                                    <span className="detail-info-label">Metode</span>
                                    <span className="detail-info-value">{this.state.orderData.MetodePembayaran}{(this.state.orderData.NamaPaymentChannel) ? ' - '+this.state.orderData.NamaPaymentChannel : ''}</span>
                                </div>
                                <div className={"detail-info-row" + (!this.state.tv_sisa_waktu_bayar ? " detail-info-row-last" : "")}>
                                    <i className="fi-rs-info"></i>
                                    <span className="detail-info-label">Status</span>
                                    <span className="detail-info-value detail-info-value-normal">{this.state.orderData.StatusPembayaranLabelNew}</span>
                                </div>
                                {
                                    this.state.tv_sisa_waktu_bayar && (
                                        <div className="detail-info-row detail-info-row-last">
                                            <i className="fi-rs-clock"></i>
                                            <span className="detail-info-label">Sisa Waktu</span>
                                            <span className="detail-countdown">{this.state.tv_sisa_waktu_bayar_view}</span>
                                        </div>
                                    )
                                }
                            </div>

                            <div className="detail-summary-box">
                                <div className="detail-summary-row">
                                    <span>Total Harga</span>
                                    <span>Rp {this.state.orderData.GrandTotal}</span>
                                </div>
                                <div className="detail-summary-row">
                                    <span>Biaya Pengiriman</span>
                                    <span>Rp {this.state.orderData.JasaKirim}</span>
                                </div>
                                <div className="detail-summary-row">
                                    <span>Biaya Admin</span>
                                    <span>Rp {this.state.orderData.BiayaAdmin}</span>
                                </div>
                                <div className="detail-summary-divider"></div>
                                <div className="detail-summary-row">
                                    <span>Point Digunakan</span>
                                    <span className="detail-summary-green">- Rp {this.state.orderData.PotonganKomisi}</span>
                                </div>
                                <div className="detail-summary-divider"></div>
                                <div className="detail-summary-row detail-summary-total">
                                    <span>Total Belanja</span>
                                    <span>Rp {this.state.orderData.TotalHargaOrder}</span>
                                </div>
                                {
                                    this.state.orderData.EstimasiKomisi && (
                                        <div className="detail-summary-row">
                                            <span>Estimasi Komisi yang akan didapatkan</span>
                                            <span>Rp {this.state.orderData.EstimasiKomisi}</span>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                        </>
                        )
                    }
                    </div>

                    {
                        showActionBar && (
                            <div className="detail-action-bar">
                                <div className="detail-action-bar-inner">
                                    {
                                        this.state.btn_cancel && (
                                            <button className="detail-btn-outline" onClick={() => {this.handleCancel()}}>
                                                Batalkan Order
                                            </button>
                                        )
                                    }
                                    {
                                        this.state.btn_payment && (
                                            <button className="detail-btn-primary" onClick={() => {this.handlePayment()}}>
                                                Lanjutkan Pembayaran
                                            </button>
                                        )
                                    }
                                    {
                                        (this.state.ll_qrcode && this.state.cv_qrcode_out) && (
                                            <>
                                                {this.state.btn_qrcode_out}
                                                {this.state.btn_qrcode_receive}
                                            </>
                                        )
                                    }
                                    {
                                        (this.state.ll_qrcode && !this.state.cv_qrcode_out) && (
                                            this.state.btn_qrcode_receive
                                        )
                                    }
                                    { this.state.btn_change_delivery }
                                    { this.state.btn_change_payment }
                                </div>
                            </div>
                        )
                    }
                </main>
            </>
        );
    }
}

export default OrderActiveDetails;
